import * as React from 'react';
import { SvgIconProps } from '@mui/material';
import AssignmentIcon from '@mui/icons-material/Assignment';

export interface SettingsModuleConfig {
  moduleKey: string;
  label: string;
  description: string;
  icon: React.ComponentType<SvgIconProps>;
  route: string;
  flagKeys: string[];
}

export const SETTINGS_MODULES: SettingsModuleConfig[] = [
  {
    moduleKey: 'solicitacoes',
    label: 'Solicitações',
    description:
      'Gerencie funcionalidades relacionadas à criação de solicitações.',
    icon: AssignmentIcon,
    route: '/configuracoes/solicitacoes',
    flagKeys: ['bulkRequest'],
  },
];

// Copy voltado ao usuário final, desacoplado do campo `description` da API
// (que é um comentário curto de seed, não texto de UI). Se uma flag nova
// ainda não tiver entrada aqui, cai de volta para `flag.description`.
export const FLAG_DISPLAY: Record<
  string,
  { title: string; helperText: string }
> = {
  bulkRequest: {
    title: 'Solicitações em Massa',
    helperText:
      'Permite criar múltiplas solicitações de uma só vez via envio em massa.',
  },
};
